import createIcon from '../../createIcon';

/**
 * @component @name HomeMax
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNUg1QzIuNzkgNSAxIDYuNzkgMSA5VjE0QzEgMTYuMjEgMi43OSAxOCA1IDE4SDdWMTlIMTdWMThIMTlDMjEuMjEgMTggMjMgMTYuMjEgMjMgMTRWOUMyMyA2Ljc5IDIxLjIxIDUgMTkgNVpNMjEgMTRDMjEgMTUuMSAyMC4xIDE2IDE5IDE2SDVDMy45IDE2IDMgMTUuMSAzIDE0VjlDMyA3LjkgMy45IDcgNSA3SDE5QzIwLjEgNyAyMSA3LjkgMjEgOVYxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HomeMax = createIcon('HomeMax', [
  [
    'path',
    {
      d: 'M19 5H5C2.79 5 1 6.79 1 9V14C1 16.21 2.79 18 5 18H7V19H17V18H19C21.21 18 23 16.21 23 14V9C23 6.79 21.21 5 19 5ZM21 14C21 15.1 20.1 16 19 16H5C3.9 16 3 15.1 3 14V9C3 7.9 3.9 7 5 7H19C20.1 7 21 7.9 21 9V14Z',
      key: '1599ob',
    },
  ],
]);

export default HomeMax;
